<template>
    <div class="dialog-advanced-filter" v-if="show">
        <div class="dialog-advanced-filter__header">
            <span class="dialog-advanced-filter__title">
                {{ translate('btn_advanced_filters') }}
            </span>
            <div class="dialog-advanced-filter__action">
                <el-link v-if="hasFilters" @click="$emit('clear')">
                    {{ translate('clear_filters') }}
                </el-link>
                <el-link @click="$emit('handleFilter', filterData)">
                    {{ translate('apply_filters') }}
                </el-link>
            </div>
        </div>
        <div class="dialog-advanced-filter__content">
            <el-form>
                <el-collapse v-model="collapseSelected">
                    <el-collapse-item
                        :title="translate('operation_date')"
                        name="1"
                    >
                        <el-date-picker
                            v-model='filterData.initialDate'
                            class='mr-2'
                            type='date'
                            :placeholder="translate('initial_date')"
                            format='dd/MM/yyyy'
                            @change="val => setDate(val, 'initialDate')"
                        /><el-date-picker
                            v-model='filterData.endDate'
                            class='mr-2'
                            type='date'
                            :placeholder="translate('end_date')"
                            format='dd/MM/yyyy'
                            @change="val => setDate(val, 'endDate')"
                        />
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('origin_destination')"
                        name="2"
                    >
                        <div class="selectcontainer_origin_destination">
                            <el-select
                                v-model='filterData.origin'
                                :placeholder="translate('select_origin_warehouse')"
                                filterable
                                clearable
                                remote
                                :remote-method="val => fetchWarehouses(val, 'origin')"
                                :loading='searchingOrigin'
                                :no-data-text="(!searchingOrigin && searchingOriginText && searchingOriginText.length < 3) ? $t('warehouse.add_modal.type_more_than_three_chars') : $t('warehouse.add_modal.no_data_text')"
                            >
                                <el-option
                                    v-for="originWarehouse in originWarehouses"
                                    :key="originWarehouse.id"
                                    :label="originWarehouse.unidade"
                                    :value="originWarehouse.id"
                                >
                                    {{ originWarehouse.unidade }}
                                </el-option>
                            </el-select>
                            <el-select
                                v-model='filterData.destination'
                                :placeholder="translate('select_destination_warehouse')"
                                filterable
                                clearable
                                remote
                                :remote-method="val => fetchWarehouses(val, 'destination')"
                                :loading='searchingDestination'
                                :no-data-text="(!searchingDestination && searchingDestinationText && searchingDestinationText.length < 3) ? $t('warehouse.add_modal.type_more_than_three_chars') : $t('warehouse.add_modal.no_data_text')"
                            >
                                <el-option
                                    v-for="destinationWarehouse in destinationWarehouses"
                                    :key="destinationWarehouse.id"
                                    :label="destinationWarehouse.unidade"
                                    :value="destinationWarehouse.id"
                                >
                                    {{ destinationWarehouse.unidade }}
                                </el-option>
                            </el-select>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('status_label')"
                        name="3"
                    >
                        <el-checkbox-group
                            v-model="filterData.status"
                            class="dialog-advanced-filter__content__status"
                            :max="1"
                        >
                            <el-checkbox label="em_transito">
                                {{ $t('contrato_rastreabilidade.messages.status.em_transito') }}
                            </el-checkbox>
                            <el-checkbox label="aprovada">
                                {{ $t('contrato_rastreabilidade.messages.status.aprovada') }}
                            </el-checkbox>
                            <el-checkbox label="reprovada">
                                {{ $t('contrato_rastreabilidade.messages.status.reprovada') }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </div>
    </div>
</template>

<script>
import ArmazemModuleService from '@/services/ArmazemModuleService';
import { operationStatusColors } from '@/modules/traceability-contract/utils';
import { mapState } from 'vuex';

export default {
    name: 'dialog-advanced-filters',
    props: {
        show: {
            type: Boolean,
            required: true,
            default: () => false
        }
    },
    data() {
        return {
            operationStatusColors: operationStatusColors,
            collapseSelected: [1],
            originWarehouses: [],
            destinationWarehouses: [],
            searchingOrigin: false,
            searchingOriginText: null,
            searchingDestination: false,
            searchingDestinationText: null,
            filterData: {
                origin: null,
                destination: null,
                initialDate: null,
                endDate: null,
                status: []
            }
        };
    },
    mounted() {
    },
    computed: {
        ...mapState('traceabilityContractModule', ['filter']),
        hasFilters() {
            return (
                this.filter.contract_number ||
                this.filter.status?.length > 0 ||
                this.filter.initialDate ||
                this.filter.endDate ||
                this.filter.origin ||
                this.filter.destination
            );
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade.messages.main_filters';
            return this.$t(`${base}.${key}`, params);
        },
        setDate(date, type) {
            if (type === 'initialDate') {
                this.filterData.initialDate = date;
            } else {
                this.filterData.endDate = date;
            }
        },

        async fetchWarehouses(query, type) {
            if (type === 'origin') {
                this.searchingOriginText = query;
                this.searchingOrigin = true;
            } else {
                this.searchingDestinationText = query;
                this.searchingDestination = false;
            }
            if (query && query.length >= 3) {
                await ArmazemModuleService.getWarehousesByName(query)
                .then(({ data }) => {
                    if (type === 'origin') {
                        this.originWarehouses = data;
                    } else {
                        this.destinationWarehouses = data;
                    }
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.translate('error_fetching_warwhouse')
                    });
                });
                this.searchingOrigin = false;
                this.searcinhDestination = false;
            } else {
                this.originWarehouses = [];
                this.destinationWarehouses = [];
            }
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-advanced-filter {
    width: 100%;

    .dialog-advanced-filter__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .dialog-advanced-filter__title {
            font-weight: 500;
            font-size: 16px;
            color: #00413c;
        }

        .dialog-advanced-filter__action {
            display: flex;
            gap: 16px;

            .el-link:first-child {
                color: #e35e58;
                font-size: 14px;
                font-weight: 400;
            }

            .el-link:last-child {
                color: #036be4;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .dialog-advanced-filter__content {
        .dialog-advanced-filter__content__status {
            display: grid;
            grid-template-columns: 1fr 1fr auto;
            gap: 16px;
        }

        .dialog-advanced-filter__content__cultivation {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            gap: 32px;
        }
    }
}
.selectcontainer_origin_destination {
    display: flex;
    gap: 16px;
}
</style>
